const pageLoadArgs = {
	'hitType': 'event', // Constant
	'eventCategory': 'page',
	'eventAction': 'pageLoad', // Constant
	'eventLabel': '',
	'eventValue': 0,
	'nonInteraction': true
};

/* Fubo Event Tracking */
if ( 0 !== document.getElementsByClassName( '.fuboWidget' ).length ) {
	const ga = window.ga || false;
	const elem = document.querySelector( '.category-header h3 a' );
	pageLoadArgs.eventLabel = `${ elem.textContent } Fubo Embed`;
	ga( 'send', pageLoadArgs ); // eslint-disable-line no-undef
}
